import { useEffect } from "react";
import { signalRStart, signalRStop } from "./signalr";
import { useAppSelector } from "../framework/redux/hooks";
import { useListenWorkTimeMessages } from "../hooks/worktime/useListenWorkTimeMessages";
import { useListenTransportOrderNotifications } from "../hooks/order/useListenTransportOrderNotifications";

export const SignalRListener = () => {
    const { accessToken } = useAppSelector((state) => state.session);

    useEffect(() => {
        if (accessToken) {
            signalRStart();
        } else {
            signalRStop();
        }
    }, [accessToken]);

    useListenWorkTimeMessages();
    useListenTransportOrderNotifications();

    return null;
};
